import { SUPPORT_CONFIG } from '@indutrust/shared-data';
import type { TopbarHelpMenuItemConfig } from '@indutrust/shared-feature';

/**
 * Builds the help menu items for the Indutrust platform topbar.
 *
 * @returns Help-menu item configs for {@link TOPBAR_HELP_ITEMS_FACTORY}.
 */
export function buildIndutrustHelpMenuItems(): TopbarHelpMenuItemConfig[] {
  return [
    {
      labelKey: 'help.documentation',
      icon: 'pi pi-file',
      routerLink: '/docs',
    },
    {
      labelKey: 'help.helpCenter',
      icon: 'pi pi-question-circle',
      routerLink: '/help-center',
    },
    {
      labelKey: 'help.contactUs',
      icon: 'pi pi-comment',
      routerLink: '/contact-us',
    },
    {
      labelKey: 'help.support',
      icon: 'pi pi-envelope',
      target: '_blank',
      url: `mailto:${SUPPORT_CONFIG.email}`,
    },
  ];
}
